import React, { useEffect, useMemo, useRef, useState } from "react";
import "./InfoMessage.css";
import "../../App.css";
import iconCross from "../../photos/cross.svg";
import { randomTilt } from "../Select.tsx";

// How long a toast takes to lift away (matches .toast-leaving)
export const TOAST_LEAVE_MS = 300;

// Toasts are stickers: slapped on at a new random angle each time one shows,
// and lifted off the top again when they close, by timer or cross. A tap
// elsewhere leaves them be.
export function InfoMessage(props) {
  const { shouldShow, setShouldShow } = props;
  // Each toast leans the other way from the last one
  const lastTilt = useRef();
  const tilt = useMemo(() => {
    if (!shouldShow) return lastTilt.current;
    lastTilt.current = randomTilt(lastTilt.current);
    return lastTilt.current;
    // A new message while one shows gets a new angle too, hence props.text
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShow, props.text]);

  // Stay on screen while lifting away after shouldShow turns false
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  useEffect(() => {
    if (shouldShow) {
      setVisible(true);
      setLeaving(false);
      return;
    }
    setLeaving(true);
    const timer = setTimeout(() => setVisible(false), TOAST_LEAVE_MS);
    return () => clearTimeout(timer);
  }, [shouldShow]);

  if (!visible) {
    return <></>;
  } else {
    const motion = leaving ? " toast-leaving" : "";
    if (!props.add) {
      return (
        <div className="toast-layer">
          <div
            className={`info-message-container toast-sticker${motion}`}
            style={{ backgroundColor: props.color, "--tilt": tilt }}
          >
            <div className="text-h4">{props.text}</div>
            <img
              src={iconCross}
              alt="Close Icon"
              className="toast-close"
              onClick={() => setShouldShow(false)}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="toast-layer">
          <div
            className={`add-container toast-sticker${motion}`}
            style={{ backgroundColor: props.color, "--tilt": tilt }}
          >
            <div className="text-h4">{props.text}</div>
          </div>
        </div>
      );
    }
  }
}
